/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum CustomerUserListAliases {
  ACTION_NEW_USER = 'action-new-user',
  CONTEXTUAL_CUSTOMER_USER = 'contextual-customer-user',
  FETCH_CUSTOMER_USER = 'fetch-customer-user',
  FIELD_EMAIL = 'field-email',
  FIELD_LOGIN = 'field-login',
  FIELD_USERNAME = 'field-username',
  FILTER_CUSTOMER_USER = 'filter-customer-user',
  FILTERED_LIST_CUSTOMER_USER = 'filtered-list-customer-user',
  INPUT_EMAIL = 'input-email',
  INPUT_LOGIN = 'input-login',
  INPUT_USERNAME = 'input-username',
  LAYOUT_CUSTOMER_USER = 'layout-customer-user',
  PAGINATOR_CUSTOMER_USER = 'paginator-customer-user',
  PANEL_CUSTOMER_USER = 'panel-customer-user',
  TABLE_COLUMN_EMAIL = 'table-column-email',
  TABLE_COLUMN_LOGIN = 'table-column-login',
  TABLE_COLUMN_NAME = 'table-column-name',
  TABLE_COLUMN_STATUS = 'table-column-status',
  TABLE_CUSTOMER_USER = 'table-customer-user',
}
export { CustomerUserListAliases };
